import UserAccess from '../../../base/errors/airdome/UserAccess';

const userAccess: UserAccess = {
  unableToLoad: 'Users with access were unable to load'
};

export default userAccess;
